import PinPad from '../Components/PinPad';
import { IPage, registerPage } from '../Components/Page';
import { Button, TextField } from '@mui/material';
import { appSettings } from '../AppSettings';
import session from '../Services/Session';
import { execAsync } from '../Utils';
import { Fragment, useEffect, useState } from 'react';
import useAppBar from '../Hooks/AppBarContext';
import { useActions } from '../Hooks/Actions';
import KeyIcon from '@mui/icons-material/Key';
import "./Login.scss"

export function LoginContent() {

    const actions = useActions();

    const appBar = useAppBar();

    const [usePin, setUsePin] = useState(true);

    const [username, setUsername] = useState("");

    const [password, setPassword] = useState("");

    const onPinChanged = (value: string) => execAsync(async () => {

        if (value.length === appSettings.pinLen) {
            await session.openAsync(value);
            actions.eventList(true);
        }
    });

    const login = () => {

    }

    useEffect(() => {

        appBar({ largeLogo: true, backVisible: true })

        actions.verifyApiUrlAsync();

    }, []);

    return (
        <Fragment>
            {usePin ?
                <div className="main login-pin">
                    <PinPad length={appSettings.pinLen} onValueChanged={onPinChanged} />
                    <Button className="login-switch" variant="text" onClick={() => setUsePin(false) } >
                        Non hai il pin?
                    </Button>
                </div>
                :
                <form className="main login-password">
                    <TextField onChange={(ev) => setUsername(ev.currentTarget.value)} label="User" variant="standard" />
                    <TextField onChange={(ev) => setPassword(ev.currentTarget.value)} type="password" label="Password" variant="standard" />
                    <Button variant="outlined" onClick={login}>Login</Button>
                    <Button className="login-switch" variant="text" onClick={() => setUsePin(true)} >
                        Hai il pin?
                    </Button>
                </form>
                }
        </Fragment>
    );
}

const Login: IPage = {

    name: "login",
    title: "Login",
    route: "/login",
    icon: <KeyIcon />,
    content: <LoginContent/>
}

registerPage(Login);

export default Login;